import React, { MouseEvent } from 'react';
import cn from 'clsx';
import { Link, Typography } from 'common/components';
import { VariantsAxisModel } from 'modules/collections';
import { createElementKey } from 'utils';
import {
  activeAxisPoint,
  axisPoint,
  axisPointName,
  axisPointsContainer,
  axisPointWrapper,
  inactiveAxisPoint,
} from './axis-points-styles';

type AxisPointProps = {
  activeProductId: string;
  axisPoints: VariantsAxisModel[];
  onPointClick: (axisId: string, productId: string) => () => void;
};

export const AxisPoints = ({ activeProductId, axisPoints, onPointClick }: AxisPointProps) => {
  const onPointWheelClick = (e: MouseEvent, attribute: string, productId: string) => {
    if (e.button === 1) {
      onPointClick(attribute, productId)();
    }
  };

  return (
    <div className={axisPointsContainer}>
      {axisPoints.map(({ axisMeta, pointsOnAxis }, index) => (
        <div key={createElementKey('axis', index)}>
          <Typography as="span" color="text-secondary" className={axisPointName} variant="caption_accent">
            {axisMeta.name}:
          </Typography>

          <div className={axisPointWrapper}>
            {pointsOnAxis.map((point, pointIndex) => (
              <Link
                className={cn(axisPoint, {
                  [activeAxisPoint]: activeProductId === point.productId,
                  [inactiveAxisPoint]: !point.available,
                })}
                href={point.productUrl}
                key={createElementKey('axis-point', pointIndex)}
                onClick={onPointClick(axisMeta.attribute, point.productId)}
                onAuxClick={e => onPointWheelClick(e, axisMeta.attribute, point.productId)}
                title={point.label}>
                <Typography variant="s" size="body_long">
                  {point.label}
                </Typography>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
